const ColorPalette = {
  light: {
    action1: (opacity = null) => `rgba(35, 46, 209, ${opacity ? opacity : 1})`, //#232ED1
    action2: (opacity = null) => `rgba(153, 160, 56, ${opacity ? opacity : 1})`, //#
    availableLight: (opacity = null) => `rgba(235, 255, 243, ${opacity ? opacity : 1})`, //#EBFFF3
    background1: (opacity = null) => `rgba(247, 246, 243, ${opacity ? opacity : 1})`, //#F7F6F3
    dark0: (opacity = null) => `rgba(0, 0, 0, ${opacity ? opacity : 1})`, //#000000
    dark1: (opacity = null) => `rgba(51, 51, 51, ${opacity ? opacity : 1})`, //#333333
    dark2: (opacity = null) => `rgba(79, 79, 79, ${opacity ? opacity : 1})`, //#4F4F4F
    dark3: (opacity = null) => `rgba(130, 130, 130, ${opacity ? opacity : 1})`, //#828282
    dark4: (opacity = null) => `rgba(189, 189, 189, ${opacity ? opacity : 1})`, //#BDBDBD
    dark5: (opacity = null) => `rgba(224, 224, 224, ${opacity ? opacity : 1})`, //#E0E0E0
    dark6: (opacity = null) => `rgba(235, 235, 235, ${opacity ? opacity : 1})`, //#EBEBEB
    error1: (opacity = null) => `rgba(215, 38, 56, ${opacity ? opacity : 1})`, //#D72638
    highlight1: (opacity = null) => `rgba(231, 243, 246, ${opacity ? opacity : 1})`, //#E7F3F6
    highlight2: (opacity = null) => `rgba(53, 135, 164, ${opacity ? opacity : 1})`, //#3587A4
    highlight3: (opacity = null) => `rgba(146, 176, 188, ${opacity ? opacity : 1})`,
    light1: (opacity = null) => `rgba(255, 255, 255, ${opacity ? opacity : 1})`, //#FFFFFF
    light2: (opacity = null) => `rgba(235, 255, 243, ${opacity ? opacity : 1})`,
    overlayBorder1: (opacity = null) => `rgba(53, 135, 164, ${opacity ? opacity : 1})`, //#3587A4
    select1: (opacity = null) => `rgba(76, 117, 242, ${opacity ? opacity : 1})`, // #4C75F2
    shadow1: (opacity = null) => `rgba(243, 246, 247, ${opacity ? opacity : 1})`, //#F3F6F7
    shadow2: (opacity = null) => `rgba(0, 0, 0, ${opacity ? opacity : 1})`,
    theme1: (opacity = null) => `rgba(243, 227, 10, ${opacity ? opacity : 1})`,
    theme2: (opacity = null) => `rgba(187, 177, 133, ${opacity ? opacity : 1})`,
    unavailable: (opacity = null) => `rgba(255, 46, 0, ${opacity ? opacity : 1})`, // #FF2E00
    unavailableLight: (opacity = null) => `rgba(255, 238, 235, ${opacity ? opacity : 1})`, //#FFEEEB
    warning1: (opacity = null) => `rgba(215, 38, 56, ${opacity ? opacity : 1})`, //#D72638
  },
  dark: {
  },
};

const getDefaultState = () => {
  return {
    isDarkMode: localStorage.getItem('is_dark_mode') || false,
  };
};

const colorTheme = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    color: state => {
      return state.isDarkMode ? ColorPalette.dark : ColorPalette.light;
    },
  },
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    switchColorMode (state) {
      state.isDarkMode = !state.isDarkMode;
      localStorage.setItem('is_dark_mode', state.isDarkMode);
    },
  },
}

export default colorTheme;
export { ColorPalette };
